export enum FinanceMenuEnum {
    Dashboard = 1,
    Revenue = 2,
    Accounting = 3,
    AccountingDashboard = 4,
    AccountingPayout = 5,
    AccountingCashflowSummary = 6,
    Payout = 7,
    Invoices = 8,
    Inventory = 9,
    XenditTransactions = 10,
    GuaranteedPay = 11,
    TopUps = 12,
    CashOut = 13,
    DriverWallet = 14,
    CustomerWallet = 15,
    Collection = 16,
    CollectionPending = 17,
    WalletTransactionHistory = 18,
    Commerce = 19,
    DriverCommerce = 24,
    CustomerCommerce = 25
}
